export default __webpack_public_path__ + "static/media/notific.c1942a0d.svg";